import { useState } from 'react';
import { useTheme } from '../context/theme';
import { useAuth } from '../context/auth';
import { N, COLORS } from '../utils/constants';
import { Btn, Inp, Logo, Avatar } from './ui';

export function Login({ sessionExpired }) {
  const { theme, isDark } = useTheme();
  const { login } = useAuth();
  const [e, sE] = useState('');
  const [p, sP] = useState('');
  const [err, sErr] = useState('');
  const [ld, sLd] = useState(false);

  const go = async (ev) => {
    ev.preventDefault();
    sErr('');
    sLd(true);
    try {
      await login(e, p);
    } catch (ex) {
      sErr(ex.message);
    }
    sLd(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <form onSubmit={go} className="fi" style={{ background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 20, padding: '40px 32px', boxShadow: '0 2px 12px rgba(0,0,0,0.4)', width: '100%', maxWidth: 400 }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
          <Logo sz={80} />
        </div>
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Email</label>
        <Inp type="email" value={e} onChange={x => sE(x.target.value)} placeholder="you@company.com" required style={{ marginBottom: 14 }} />
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Password</label>
        <Inp type="password" value={p} onChange={x => sP(x.target.value)} placeholder="••••••••" required style={{ marginBottom: 20 }} />
        {sessionExpired && !err && <div style={{ padding: '8px 12px', background: 'rgba(251,191,36,0.10)', color: '#F59E0B', borderRadius: 8, fontSize: 13, marginBottom: 14 }}>Your session expired — please sign in again</div>}
        {err && <div style={{ padding: '8px 12px', background: 'rgba(255,71,87,0.13)', color: '#EF4444', borderRadius: 8, fontSize: 14, marginBottom: 14 }}>{err}</div>}
        <Btn primary full dis={ld} style={{ padding: 14, fontSize: 14 }}>{ld ? 'Signing in...' : 'Sign In'}</Btn>
      </form>
    </div>
  );
}

export function Onboard({ user, onDone }) {
  const { theme, isDark } = useTheme();
  const [name, sN] = useState(user.name || '');
  const [title, sT] = useState('');
  const [phone, sPh] = useState('');
  const [pw, sPw] = useState('');
  const [color, sC] = useState(user.avatar_color || N);
  const [err, sErr] = useState('');

  const go = async () => {
    sErr('');
    try {
      await api.post('/api/auth/onboard', { name, title, phone, newPassword: pw || undefined, avatar_color: color });
      onDone();
    } catch (e) {
      sErr(e.message);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div className="su" style={{ background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 20, padding: '40px 32px', boxShadow: '0 2px 12px rgba(0,0,0,0.4)', width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Avatar name={name} color={color} sz={64} />
          <h2 style={{ fontSize: 28, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", letterSpacing: '-0.02em', color: '#FFFFFF', marginTop: 12, lineHeight: 1.2 }}>Welcome to Lightning Partners HQ</h2>
          <p style={{ color: 'rgba(255,255,255,0.58)', fontSize: 13 }}>Set up your profile to get started</p>
        </div>
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Your Name</label>
        <Inp value={name} onChange={x => sN(x.target.value)} style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Job Title</label>
        <Inp value={title} onChange={x => sT(x.target.value)} placeholder="e.g. Project Manager" style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Phone (optional)</label>
        <Inp value={phone} onChange={x => sPh(x.target.value)} placeholder="555-123-4567" style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>New Password (min 8 chars)</label>
        <Inp type="password" value={pw} onChange={x => sPw(x.target.value)} placeholder="Set your own password" style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 14, color: 'rgba(255,255,255,0.58)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 }}>Profile Color</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
          {COLORS.map(c => (
            <div key={c} className="color-swatch" onClick={() => sC(c)} style={{ width: 28, height: 28, borderRadius: 8, background: c, cursor: 'pointer', border: color === c ? '2px solid #fff' : '2px solid transparent', transition: 'border .15s' }} />
          ))}
        </div>
        {err && <div style={{ color: '#EF4444', fontSize: 14, marginBottom: 10 }}>{err}</div>}
        <Btn primary full onClick={go} style={{ padding: 14, fontSize: 14 }}>Complete Setup</Btn>
      </div>
    </div>
  );
}
